export default __webpack_public_path__ + "static/staff01-1161efff3631349ad60acef9cebacf67.png";